window.initCountUp = function initCountUp() {
  const counts = document.querySelectorAll('.count-up');
  if (!counts.length) return;

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const count = entry.target;

        if (!count.dataset.target) {
          count.dataset.target = count.textContent.trim();
        }

        const target = parseFloat(count.dataset.target) || 0;
        const duration = parseFloat(count.dataset.duration) || 1200; // мс
        const start = performance.now();

        function animate(time) {
          const progress = Math.min((time - start) / duration, 1);
          const value = Math.floor(progress * target);

          count.textContent = value;

          if (progress < 1) {
            requestAnimationFrame(animate);
          } else {
            count.textContent = target;
          }
        }

        count.textContent = '0';
        requestAnimationFrame(animate);

        obs.unobserve(count);
      });
    },
    {
      threshold: 0,
      rootMargin: window.innerWidth >= 640 ? '0% 0% -10% 0%' : '0% 0% -5% 0%',
    }
  );

  counts.forEach((count) => observer.observe(count));
};
